import propsTag from '@/js/util/props/propsTag'

export default {
  props: { ...propsTag },
  render(createElement) {
    const slot = this.$slots.default.map((vnode) => {
      let node = vnode
      const { tag } = vnode
      const wrappableTags = ['iframe', 'table']
      if (wrappableTags.includes(tag)) {
        node = createElement('div', {
          staticClass: `wysiwyg__${tag}`,
        }, [vnode])
      }
      return node
    })
    return createElement(this.tag, slot)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseWysiwyg.js